<generic-incident-modal [parent]="this" [busy]="busy">
    <form [formGroup]="form">
        <h2>NSF Details</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Check Number</label>
                    <input type="text" class="mvd_form-control" formControlName="checkNumber" [attr.disabled]="data.incident.statusTypeId == 4 ? true : null" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Check Amount</label>
                    <input type="text" class="mvd_form-control" formControlName="checkAmount" [attr.disabled]="data.incident.statusTypeId == 4 ? true : null" />
                </div>
            </div>
        </fieldset>

        <h2>Customer</h2>
        <fieldset>
            <div class="mvd_form-group" *ngIf="!data.isReadOnly">
                <customer-search-bar id="incidentCustomerSearch" #customerSearchBar label="Add Customer" (onItemSelected)="addCustomer($event)"></customer-search-bar>
            </div>
            <div class="mvd_form-group">
                <label>Existing Customer(s)</label>
                <div class="search--omni" *ngFor="let customer of data.incident.customers">
                    <ul>
                        <li class="search--omni__image">
                            <customer-photo [classes]="'mvd_photo'" [customerNumberId]="customer.id" [legacySequenceNumber]="customer.legacySequenceNumber"></customer-photo>
                        </li>
                        <li>
                            <div><b>{{ customer.firstName }} {{ customer.middleName }} {{ customer.lastName }}</b></div>
                            <div>{{ customer | address }}</div>
                        </li>
                        <li class="search--omni__remove">
                            <a class="icon--remove" title="Remove" href="javascript:void(0)" (click)="confirmRemoveCustomer(customer)" *ngIf="!data.isReadOnly"></a>
                        </li>
                    </ul>
                </div>
            </div>
        </fieldset>
    </form>
</generic-incident-modal>